import type { FC } from 'react'
import React from 'react'
import styles from './TitleDesktop.module.scss'
import { useLocalisation } from '@/tools/i18n/client'
import { ChevronBackwardIcon, IconButton, IconButtonSize, IconButtonVariants } from '@/tools/ui'

interface Props {
  title: string
  onBackClick?: () => void
}
export const TitleDesktop: FC<Props> = ({ title, onBackClick }) => {
  const { t } = useLocalisation()

  const handleOnClick = () => {
    if (!onBackClick) {
      return
    }
    onBackClick()
  }

  return (
    <div className={styles.titleDesktop}>
      {onBackClick && (
        <IconButton
          aria-label={t('glovo.common.back')}
          icon={ChevronBackwardIcon}
          size={IconButtonSize.medium}
          variant={IconButtonVariants.transparent}
          onClick={handleOnClick}
        />
      )}
      <p>{title}</p>
    </div>
  )
}
